import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  PurchaseLedgerModule,
  PurchaseProductModule,
  StaffPurchaseModule,
  PurchaseStepModule,
  StaffAuthModule,
  StaffModule,
} from './services';
import { StaffGroupModule } from './services/group';
import { StaffFileModule } from './services/file/file.module';
import { StaffBoardModule } from './services/board';
@NgModule({
  imports: [
    StaffAuthModule,
    StaffGroupModule,
    StaffBoardModule,
    StaffModule,
    PurchaseProductModule,
    StaffPurchaseModule,
    PurchaseLedgerModule,
    PurchaseStepModule,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        ...(PurchaseProductModule.forRoot().providers || []),
        ...(StaffPurchaseModule.forRoot().providers || []),
        ...(PurchaseLedgerModule.forRoot().providers || []),
        ...(PurchaseStepModule.forRoot().providers || []),
        ...(StaffAuthModule.forRoot().providers || []),
        ...(StaffModule.forRoot().providers || []),
        ...(StaffGroupModule.forRoot().providers || []),
        ...(StaffBoardModule.forRoot().providers || []),
        ...(StaffFileModule.forRoot().providers || []),
      ],
    };
  }
}
